export default class cSocket{
    constructor(options) {
        this.settings = {
            ...this.defaults,
            ...options,
            count:0
        }
        this.socket = null
        this.init()
    }

    init() {
        this.socket = null
        const wss = this.settings.wss+'?token='+this.settings.token
        this.socket = new WebSocket(wss)

        this.socket.onopen = () => {
            this.log('Сокет открыт');
            this.count = 0
        };
        this.socket.onclose = (event) => {
            this.log('Сокет закрыт');
            this.count += 1

            const maxBad = this.settings.maxBadMessages || 0
            if (maxBad > 0 && this.badMessageCount >= maxBad) {
                this.error('Сервер шлёт невалидный JSON — прекращаю быстрый реконнект', this.badMessageCount)
                if (this.settings.loopReconnect && !this._loopInterval) this.loopReconnect()
                this.settings.onErrorConnection?.();
                return
            }

            if(this.count <= 3) {
                this.reconnect()
                this.log('Попытка переподключения', this.count)
            } else {
                this.error('Превышено количество попыток переподключения', this.count)
                if(this.settings.loopReconnect) this.loopReconnect()
                this.settings.onErrorConnection?.();
            }
        }
        this.socket.onerror = (e) => {
            this.error('ошибка: '+e.message);
        }

        this.socket.onmessage = (event) => {
            //this.log('',event.data);
            this.onmessage(event)
        }
    }
    events() {

    }

    onmessage(event) {
        this.log('onmessage',event);
        if(event.data ==  'Authenticated') {
            this.log(event.data);
            this.badMessageCount = 0
            return
        }

        let data
        try {
            data = JSON.parse(event.data)
        } catch(e) {
            this.error('JSON.parse',{e,event});
            if (this.settings.maxBadMessages > 0) {
                this.badMessageCount = (this.badMessageCount || 0) + 1
                if (this.socket && this.socket.readyState === WebSocket.OPEN) {
                    try { this.socket.close() } catch(_) {}
                }
            }
            return
        }

        this.badMessageCount = 0
        const { action } = data
        this.settings.onmessage(action, data)
    }

    emit(data) {
        //this.log('emit',data)
        const body = JSON.stringify(data.data)
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket[data.method](body)
        } else {
            this.error('WebSocket is already in CLOSING or CLOSED state.', {data}, this.socket)
            if(this.settings.loopReconnect && !this._loopInterval) this.loopReconnect()
            this.settings.onErrorConnection?.();
        }
    }

    log(message,data) {
        if(!this.settings.console) return
        const mess = 'socket ' +this.settings.name +': '+message
        
        let _data 
        try {
            _data =JSON.parse(data)
        } catch(e) {
            _data = data
        }
        _data  = _data?.message || _data || ''
        // console.log('%c'+mess,'color: #0DD;', {socket:this.socket}, {_data})
    }
    error(message,data) {
        const mess = 'socket ' +this.settings.name +': '+message
        let _data 
        try {
            _data =JSON.parse(data)
        } catch(e) {
            _data = data
        }
        _data  = _data?.message || _data || ''
        // console.error(mess, {socket:this.socket}, _data)
    }

    reconnect() {
        let time = 1000 
        setTimeout(() => {
            this.init()
        }, time); 
    }

    loopReconnect() {
        const interval = this.settings.reconnectTime || 60000; // 1 минута по умолчанию
        this.log(`Начинаю постоянные попытки подключения каждые ${interval / 1000} сек.`);

        const tryReconnect = () => {
            if (this.socket && this.socket.readyState === WebSocket.OPEN) {
                this.log('Соединение восстановлено, останавливаю loopReconnect');
                clearInterval(this._loopInterval);
                this._loopInterval = null;
                return;
            }

            this.log('Попытка переподключения (loopReconnect)...');
            this.init();
        };

        // если уже крутится — не дублируем
        if (this._loopInterval) {
            this.log('loopReconnect уже запущен');
            return;
        }

        // первая попытка сразу
        tryReconnect();

        // дальше каждые interval мс
        this._loopInterval = setInterval(tryReconnect, interval);
    }

    get socket() {
        return this.settings.socket
    }

    set socket(value) {
        this.settings.socket = value
    }

    get count() {
        return this.settings.count
    }

    set count(value) {
        this.settings.count = value
    }

    get defaults() {
        return {
            reconnectTime: 1000,
            refreshTime: 1000,
            loopReconnect: false,
            console: true
        }
    }
}